import RequestService from '../../../services/request-service';

/**
 * Service for getting fixture menu
 */
export default class BetBuilderTournamentRequestService extends RequestService {
  /**
   * Class constructor method
   */
  constructor(tournamentData = [], tournamentGroupData = []) {
    super();
    this.method = 'get';
    this.endpoint = this.$config.endpoints.betBuilderTournamentMatches;
    this.getParams = {
      SportData: [],
      CategoryData: [],
      CategoryGroupData: [],
      TournamentData: tournamentData,
      TournamentGroupData: tournamentGroupData,
      TimeFilter: 0,
      Limit: 220,
      culture: APP_SETTINGS.player.language || 'en',
    };
    this.headers = null;
  }
}
